import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFadeInOnScroll } from '../../../hooks/useFadeInOnScroll';
import { AnimatedContainer, SectionHeader, EnhancedSectionTitle, SectionSubtitle } from '../../styles/sharedComponents';
import IntegrationCard from './IntegrationCard';
import {
  IntegrationsSection,
  IntegrationsNetwork,
  NeuralNetworkBackground,
  IntegrationsGrid
} from './styles';

const Integrations: React.FC = () => {
  const { t } = useTranslation();
  const [integrationsRef, integrationsVisible] = useFadeInOnScroll<HTMLElement>({
    direction: 'up',
    distance: 60,
    delay: 200,
  });

  const integrations = [
    {
      name: t('integrations.items.whatsapp.title'),
      icon: '/icons/whatsapp_icon.webp',
      available: true,
      angle: 0,
      description: t('integrations.items.whatsapp.description'),
      features: t('integrations.items.whatsapp.features', { returnObjects: true }) as string[]
    },
    {
      name: t('integrations.items.kiwify.title'),
      icon: '/icons/kiwifi_icon.webp',
      available: true,
      angle: 45,
      description: t('integrations.items.kiwify.description'),
      features: t('integrations.items.kiwify.features', { returnObjects: true }) as string[]
    },
    {
      name: t('integrations.items.braip.title'),
      icon: '/icons/braip_icon.webp',
      available: true,
      angle: 90,
      description: t('integrations.items.braip.description'),
      features: t('integrations.items.braip.features', { returnObjects: true }) as string[]
    },
    {
      name: t('integrations.items.gmail.title'),
      icon: '/icons/gmail_icon.webp',
      available: true,
      angle: 135,
      description: t('integrations.items.gmail.description'),
      features: t('integrations.items.gmail.features', { returnObjects: true }) as string[]
    },
    {
      name: t('integrations.items.facebook.title'),
      icon: '/icons/facebook_icon.webp',
      available: true,
      angle: 180,
      description: t('integrations.items.facebook.description'),
      features: t('integrations.items.facebook.features', { returnObjects: true }) as string[]
    }
  ];

  return (
    <IntegrationsSection ref={integrationsRef} id="integrations" $isVisible={integrationsVisible}>
      <AnimatedContainer $isVisible={integrationsVisible}>
        <SectionHeader>
          <EnhancedSectionTitle>{t('integrations.title')}</EnhancedSectionTitle>
          <SectionSubtitle>
            {t('integrations.subtitle')}
          </SectionSubtitle>
        </SectionHeader>

        <IntegrationsNetwork $isVisible={integrationsVisible}>
          <NeuralNetworkBackground $isVisible={integrationsVisible} />

          <IntegrationsGrid>
            {integrations.map((integration, index) => {
              const emergenceDelay = index * 200;

              return (
                <IntegrationCard
                  key={integration.name}
                  integration={integration}
                  isVisible={integrationsVisible}
                  delay={emergenceDelay}
                />
              );
            })}
          </IntegrationsGrid>
        </IntegrationsNetwork>
      </AnimatedContainer>
    </IntegrationsSection>
  );
};

export default Integrations;
